import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Stale-chunk error after a redeploy: force a one-time reload to fetch the
    // fresh build instead of showing a dead-end error screen.
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      /Loading chunk [\d]+ failed/i.test(error?.message || "") ||
      /dynamically imported module/i.test(error?.message || "");
    if (isChunkError && !window.sessionStorage.getItem("medisure-chunk-reloaded")) {
      window.sessionStorage.setItem("medisure-chunk-reloaded", "1");
      window.location.reload();
      return;
    }
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "40px",
            textAlign: "center",
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
          }}
        >
          <div
            style={{
              width: 80,
              height: 80,
              borderRadius: 20,
              background: "linear-gradient(135deg, rgba(244,63,94,0.1), rgba(244,63,94,0.05))",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 24,
              border: "1px solid rgba(244,63,94,0.2)",
            }}
          >
            <i
              className="fa-solid fa-triangle-exclamation"
              style={{ fontSize: "2rem", color: "#f43f5e" }}
            />
          </div>
          <h2
            style={{
              margin: "0 0 8px",
              fontSize: "1.5rem",
              fontWeight: 700,
              color: "var(--text, #1f2937)",
            }}
          >
            Something went wrong
          </h2>
          <p
            style={{
              margin: "0 0 24px",
              fontSize: "0.95rem",
              color: "var(--muted, #6b7280)",
              maxWidth: 420,
            }}
          >
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", justifyContent: "center" }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: "12px 28px",
                borderRadius: 12,
                border: "1px solid var(--border, #e5e7eb)",
                background: "transparent",
                color: "var(--text, #1f2937)",
                fontSize: "0.95rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Try again
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "12px 28px",
                borderRadius: 12,
                border: "none",
                background: "var(--brand-500, #7c3aed)",
                color: "#fff",
                fontSize: "0.95rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Refresh Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
